export default "__VITE_ASSET__i6qhKdun__"